import styled from 'styled-components'

import { NEUTRAL_COLOURS } from 'constants/colors'

export const StyledWrapper = styled.div`
  background: ${NEUTRAL_COLOURS.GRAY_QUINARY};
  border-radius: 16px;
  padding: 24px 20px;
  margin-bottom: 20px;
`

export const StyledWeekContainer = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin: 0 0 10px;
  padding: 0 0 5px;
`

export const StyledWeekDay = styled.div`
  flex: 1 1 135px;
  min-height: 150px;
  min-width: 135px;
  background: ${NEUTRAL_COLOURS.WHITE};
  border: 1px solid ${NEUTRAL_COLOURS.GRAY_TERTIARY};
  border-radius: 8px;
  display: grid;
  grid-template-rows: auto 1fr auto;

  ul {
    margin: 0;
    padding-left: 15px;
  }
`

export const StyledHeader = styled.header`
  border-bottom: 1px dashed ${NEUTRAL_COLOURS.GRAY_TERTIARY};
  padding: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledFooter = styled.footer`
  padding: 8px;
  display: flex;
  flex-direction: column;
  border-top: 1px dashed ${NEUTRAL_COLOURS.GRAY_TERTIARY};
`
